<template>
	<div class="header">
		<b-container>
			<b-navbar>
				<b-navbar-brand href="#">
					<img :src="img" alt="" class="head_img">
				</b-navbar-brand>
				<b-navbar-brand href="#">
					<div class="name">{{name}}</div>
					<div class="ym">{{domain}}</div>
				</b-navbar-brand>
				<b-navbar-nav class="ml-auto">
					<b-nav-item href="/home" class="pr-5" style="position: relative;" @click="Herf('home')">
						首页
						<div class="bottom-line" v-show="locationPpathname == 'home'"></div>
					</b-nav-item>
					<b-nav-item href="" class="pr-5" style="position: relative;" @click="Herf('server')">
						服务
						<div class="bottom-line" v-show="locationPpathname == 'server'"></div>
					</b-nav-item>
					<b-nav-item href="" class="pr-5" style="position: relative;" @click="Herf('case')">
						案例
						<div class="bottom-line" v-show="locationPpathname == 'case'"></div>
					</b-nav-item>
					<b-nav-item href="" class="pr-5" style="position: relative;" @click="Herf('team')">
						团队
						<div class="bottom-line" v-show="locationPpathname == 'team'"></div>
					</b-nav-item>
					<b-nav-item href="" class="pr-5" @click="Herf('call')" style="position: relative;">
						联系我们
						<div class="bottom-line" v-show="locationPpathname == 'call'"></div>
					</b-nav-item>
				</b-navbar-nav>
			</b-navbar>

		</b-container>
	</div>
</template>

<script>
	import axios from 'axios'
	import local from '../utils/local'

	export default {
		data() {
			return {
				locationPpathname: '',
				domain: "",
				img: "",
				name: ""
			};
		},
		methods: {
			Herf(data) {
				if (this.$route.path == '/' || this.$route.path == '/home') {
					this.locationPpathname = data;
					this.$emit("name", this.locationPpathname);

				} else {
					this.locationPpathname = data;

						this.$router.push('/home')

					this.$nextTick(() => {
					this.$emit("name", this.locationPpathname);

					});

				}
			},
			getInfo() {
				axios.post('http://api1.home.didigo.es/admin/admin/index').then(res => {
					this.img = res.data.data.msg[0].logo;
					this.domain = res.data.data.par[0].domain;
					this.name = res.data.data.par[0].name;
				})

			}
		},
		mounted() {
			this.locationPpathname = 'home';

		},
		created() {
			this.getInfo();

		}
	};
</script>

<style type="text/css">
	.header {
		box-shadow: 0 8px 10px -6px #d5d5d5;
		width: 100%;
		height: 80px;
		background-color: #fff;
		width: 100%;
		position: fixed;
		z-index: 1000;

	}

	.head_img {
		width: 37px;
	}

	.name {
		font-size: 16px;
		font-weight: bold;
		color: #666;
	}

	.ym {
		font-size: 12px;
		color: #999;

	}

	.navbar-light .navbar-nav .nav-link {
		position: relative;
		font-size: 14px;
	}

	.navbar-light .navbar-nav .nav-link:hover {
		color: #28A6FC;
	}

	.bottom-line {
		width: 100%;
		position: absolute;
		left: 0;
		right: 0;
		height: 2px;
		background: #28A6FC;
		color: #28A6FC;
		bottom: -5px;
	}
</style>